import { request } from '@/utils/request'

export function getTree(params,token) {
  return request({
    url: '/exam/category/brush/getTree',
    method: 'get',
    params,
    headers: {
      'Authorization':  `Bearer ${token}`,
      // 'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjo5NywidXNlcl9pZCI6MTAwODMsIm9yZ19pZCI6MCwidXNlcl9rZXkiOiI4MDhhOGFhNC1hODBkLTQ2MTgtYWFhYS05OGFhMDZiZjhkZGYiLCJkZXZpY2VfdHlwZSI6IkFkbWluIiwidXNlcm5hbWUiOiIxMzEyMzQ1Njc4OSJ9.VpuEio7AYezrz0th46937Ci9corawKYVvwDkGsNhelrQDvpNSS-Wd17NzCR-Z6127g4MqgPSWDDgzZ55KidOtA`,
      'Device-Type': 'app' 
    }
  })
}

export function studyBankList(params) {
  return request({
    url: '/exam/proprietaryStudyBank/list',
    method: 'get',
    params,
    headers: {
      // 'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjo5NywidXNlcl9pZCI6MTAwODMsIm9yZ19pZCI6MCwidXNlcl9rZXkiOiI4MDhhOGFhNC1hODBkLTQ2MTgtYWFhYS05OGFhMDZiZjhkZGYiLCJkZXZpY2VfdHlwZSI6IkFkbWluIiwidXNlcm5hbWUiOiIxMzEyMzQ1Njc4OSJ9.VpuEio7AYezrz0th46937Ci9corawKYVvwDkGsNhelrQDvpNSS-Wd17NzCR-Z6127g4MqgPSWDDgzZ55KidOtA`,
      'Device-Type': 'app' 
    }
  })
}

export function getByStudyBankId(studyBankId) {
  return request({
    url: `/exam/proprietaryStudyRecord/getByStudyBankId/${studyBankId}`,
    method: 'get',
    headers: {
      // 'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjo5NywidXNlcl9pZCI6MTAwODMsIm9yZ19pZCI6MCwidXNlcl9rZXkiOiI4MDhhOGFhNC1hODBkLTQ2MTgtYWFhYS05OGFhMDZiZjhkZGYiLCJkZXZpY2VfdHlwZSI6IkFkbWluIiwidXNlcm5hbWUiOiIxMzEyMzQ1Njc4OSJ9.VpuEio7AYezrz0th46937Ci9corawKYVvwDkGsNhelrQDvpNSS-Wd17NzCR-Z6127g4MqgPSWDDgzZ55KidOtA`,
      'Device-Type': 'app' 
    }
  })
}

export function getQuestions(data) {
  return request({
    url: `/exam/proprietaryStudyRecord/getQuestions`,
    method: 'post',
    data,
    headers: {
      // 'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjo5NywidXNlcl9pZCI6MTAwODMsIm9yZ19pZCI6MCwidXNlcl9rZXkiOiI4MDhhOGFhNC1hODBkLTQ2MTgtYWFhYS05OGFhMDZiZjhkZGYiLCJkZXZpY2VfdHlwZSI6IkFkbWluIiwidXNlcm5hbWUiOiIxMzEyMzQ1Njc4OSJ9.VpuEio7AYezrz0th46937Ci9corawKYVvwDkGsNhelrQDvpNSS-Wd17NzCR-Z6127g4MqgPSWDDgzZ55KidOtA`,
      'Device-Type': 'app' 
    }
  })
}


export function addQuestion(data) {
  return request({
    url: `/exam/proprietaryStudyQuestionRecord/add`,
    method: 'post',
    data,
    headers: {
      // 'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjo5NywidXNlcl9pZCI6MTAwODMsIm9yZ19pZCI6MCwidXNlcl9rZXkiOiI4MDhhOGFhNC1hODBkLTQ2MTgtYWFhYS05OGFhMDZiZjhkZGYiLCJkZXZpY2VfdHlwZSI6IkFkbWluIiwidXNlcm5hbWUiOiIxMzEyMzQ1Njc4OSJ9.VpuEio7AYezrz0th46937Ci9corawKYVvwDkGsNhelrQDvpNSS-Wd17NzCR-Z6127g4MqgPSWDDgzZ55KidOtA`,
      'Device-Type': 'app' 
    }
  })
}

// 根据id查询学习笔记
export function getQuestionsQuestionId(questionId) {
  return request({
    url: `/exam/proprietaryQuestionResource/getById/${questionId}`,
    method: 'get',
    headers: {
      // 'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjo5NywidXNlcl9pZCI6MTAwODMsIm9yZ19pZCI6MCwidXNlcl9rZXkiOiI4MDhhOGFhNC1hODBkLTQ2MTgtYWFhYS05OGFhMDZiZjhkZGYiLCJkZXZpY2VfdHlwZSI6IkFkbWluIiwidXNlcm5hbWUiOiIxMzEyMzQ1Njc4OSJ9.VpuEio7AYezrz0th46937Ci9corawKYVvwDkGsNhelrQDvpNSS-Wd17NzCR-Z6127g4MqgPSWDDgzZ55KidOtA`,
      'Device-Type': 'app' 
    }
  })
}


// 新增学习笔记
export function addQuestionResource(data) {
  return request({
    url: `/exam/proprietaryQuestionResource/add`,
    method: 'post',
    data,
    headers: {
      // 'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjo5NywidXNlcl9pZCI6MTAwODMsIm9yZ19pZCI6MCwidXNlcl9rZXkiOiI4MDhhOGFhNC1hODBkLTQ2MTgtYWFhYS05OGFhMDZiZjhkZGYiLCJkZXZpY2VfdHlwZSI6IkFkbWluIiwidXNlcm5hbWUiOiIxMzEyMzQ1Njc4OSJ9.VpuEio7AYezrz0th46937Ci9corawKYVvwDkGsNhelrQDvpNSS-Wd17NzCR-Z6127g4MqgPSWDDgzZ55KidOtA`,
      'Device-Type': 'app' 
    }
  })
}

// 错题收藏
export function studyBankGetById(studyBankId,type) {
  return request({
    url: `/exam/proprietaryStudyBank/getByIdAndType/${studyBankId}/${type}`,
    method: 'get',
    headers: {
      // 'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjo5NywidXNlcl9pZCI6MTAwODMsIm9yZ19pZCI6MCwidXNlcl9rZXkiOiI4MDhhOGFhNC1hODBkLTQ2MTgtYWFhYS05OGFhMDZiZjhkZGYiLCJkZXZpY2VfdHlwZSI6IkFkbWluIiwidXNlcm5hbWUiOiIxMzEyMzQ1Njc4OSJ9.VpuEio7AYezrz0th46937Ci9corawKYVvwDkGsNhelrQDvpNSS-Wd17NzCR-Z6127g4MqgPSWDDgzZ55KidOtA`,
      'Device-Type': 'app' 
    }
  })
}

// 根据三级题库id查询错题-收藏
export function getQuestionsList(data) {
  return request({
    url: '/exam/proprietaryStudyRecord/getQuestions',
    method: 'post',
    data,
    headers: {
      // 'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjo5NywidXNlcl9pZCI6MTAwODMsIm9yZ19pZCI6MCwidXNlcl9rZXkiOiI4MDhhOGFhNC1hODBkLTQ2MTgtYWFhYS05OGFhMDZiZjhkZGYiLCJkZXZpY2VfdHlwZSI6IkFkbWluIiwidXNlcm5hbWUiOiIxMzEyMzQ1Njc4OSJ9.VpuEio7AYezrz0th46937Ci9corawKYVvwDkGsNhelrQDvpNSS-Wd17NzCR-Z6127g4MqgPSWDDgzZ55KidOtA`,
      'Device-Type': 'app' 
    }
  })
}

// 查询全部学习笔记
export function questionResourceList(params) {
  return request({
    url: '/exam/proprietaryQuestionResource/list',
    method: 'get',
    params,
    headers: {
      // 'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjo5NywidXNlcl9pZCI6MTAwODMsIm9yZ19pZCI6MCwidXNlcl9rZXkiOiI4MDhhOGFhNC1hODBkLTQ2MTgtYWFhYS05OGFhMDZiZjhkZGYiLCJkZXZpY2VfdHlwZSI6IkFkbWluIiwidXNlcm5hbWUiOiIxMzEyMzQ1Njc4OSJ9.VpuEio7AYezrz0th46937Ci9corawKYVvwDkGsNhelrQDvpNSS-Wd17NzCR-Z6127g4MqgPSWDDgzZ55KidOtA`,
      'Device-Type': 'app' 
    }
  })
}

// 获取问题详情
export function getOneQuestionId(questionId) {
  return request({
    url: `/exam/proprietaryQuestion/getOne/${questionId}`,
    method: 'get',
    headers: {
      // 'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjo5NywidXNlcl9pZCI6MTAwODMsIm9yZ19pZCI6MCwidXNlcl9rZXkiOiI4MDhhOGFhNC1hODBkLTQ2MTgtYWFhYS05OGFhMDZiZjhkZGYiLCJkZXZpY2VfdHlwZSI6IkFkbWluIiwidXNlcm5hbWUiOiIxMzEyMzQ1Njc4OSJ9.VpuEio7AYezrz0th46937Ci9corawKYVvwDkGsNhelrQDvpNSS-Wd17NzCR-Z6127g4MqgPSWDDgzZ55KidOtA`,
      'Device-Type': 'app' 
    }
  })
}

// 获取学科数据
export function getSubjectTree(studyBankId,token) {
  return request({
    url: `/exam/proprietaryStudyBank/getById/${studyBankId}`,
    method: 'get',
    headers: {
      // 'Authorization':  `Bearer ${token}`,
      // 'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjo5NywidXNlcl9pZCI6MTAwODMsIm9yZ19pZCI6MCwidXNlcl9rZXkiOiI4MDhhOGFhNC1hODBkLTQ2MTgtYWFhYS05OGFhMDZiZjhkZGYiLCJkZXZpY2VfdHlwZSI6IkFkbWluIiwidXNlcm5hbWUiOiIxMzEyMzQ1Njc4OSJ9.VpuEio7AYezrz0th46937Ci9corawKYVvwDkGsNhelrQDvpNSS-Wd17NzCR-Z6127g4MqgPSWDDgzZ55KidOtA`,
      'Device-Type': 'app' 
    }
  })
}

// 查询符合条件的题目数量
export function getNum(params) {
  return request({
    url: `/exam/proprietaryStudyPaper/getQuestionNum`,
    method: 'get',
    params,
    headers: {
      // 'Authorization':  `Bearer ${token}`,
      // 'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjo5NywidXNlcl9pZCI6MTAwODMsIm9yZ19pZCI6MCwidXNlcl9rZXkiOiI4MDhhOGFhNC1hODBkLTQ2MTgtYWFhYS05OGFhMDZiZjhkZGYiLCJkZXZpY2VfdHlwZSI6IkFkbWluIiwidXNlcm5hbWUiOiIxMzEyMzQ1Njc4OSJ9.VpuEio7AYezrz0th46937Ci9corawKYVvwDkGsNhelrQDvpNSS-Wd17NzCR-Z6127g4MqgPSWDDgzZ55KidOtA`,
      'Device-Type': 'app' 
    }
  })
}

// 新增智能组题
export function addAnswer(data) {
  return request({
    url: `/exam/proprietaryStudyPaper/add`,
    method: 'post',
    data,
    headers: {
      // 'Authorization':  `Bearer ${token}`,
      // 'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjo5NywidXNlcl9pZCI6MTAwODMsIm9yZ19pZCI6MCwidXNlcl9rZXkiOiI4MDhhOGFhNC1hODBkLTQ2MTgtYWFhYS05OGFhMDZiZjhkZGYiLCJkZXZpY2VfdHlwZSI6IkFkbWluIiwidXNlcm5hbWUiOiIxMzEyMzQ1Njc4OSJ9.VpuEio7AYezrz0th46937Ci9corawKYVvwDkGsNhelrQDvpNSS-Wd17NzCR-Z6127g4MqgPSWDDgzZ55KidOtA`,
      'Device-Type': 'app' 
    }
  })
}

// 根据id查询智能组题表
export function studyPaperGetById(studyPaperId,params) {
  return request({
    url: `/exam/proprietaryStudyPaper/getById/${studyPaperId}`,
    method: 'get',
    params,
    headers: {
      // 'Authorization':  `Bearer ${token}`,
      // 'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjo5NywidXNlcl9pZCI6MTAwODMsIm9yZ19pZCI6MCwidXNlcl9rZXkiOiI4MDhhOGFhNC1hODBkLTQ2MTgtYWFhYS05OGFhMDZiZjhkZGYiLCJkZXZpY2VfdHlwZSI6IkFkbWluIiwidXNlcm5hbWUiOiIxMzEyMzQ1Njc4OSJ9.VpuEio7AYezrz0th46937Ci9corawKYVvwDkGsNhelrQDvpNSS-Wd17NzCR-Z6127g4MqgPSWDDgzZ55KidOtA`,
      'Device-Type': 'app' 
    }
  })
}

// 答题
export function addQuestionResult(data) {
  return request({
    url: `/exam/proprietaryStudyPaper/questionResult/add`,
    method: 'post',
    data,
    headers: {
      // 'Authorization':  `Bearer ${token}`,
      // 'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjo5NywidXNlcl9pZCI6MTAwODMsIm9yZ19pZCI6MCwidXNlcl9rZXkiOiI4MDhhOGFhNC1hODBkLTQ2MTgtYWFhYS05OGFhMDZiZjhkZGYiLCJkZXZpY2VfdHlwZSI6IkFkbWluIiwidXNlcm5hbWUiOiIxMzEyMzQ1Njc4OSJ9.VpuEio7AYezrz0th46937Ci9corawKYVvwDkGsNhelrQDvpNSS-Wd17NzCR-Z6127g4MqgPSWDDgzZ55KidOtA`,
      'Device-Type': 'app' 
    }
  })
}

// 分页查询智能组题表
export function studyPaperPage(params) {
  return request({
    url: `/exam/proprietaryStudyPaper/page`,
    method: 'get',
    params,
    headers: {
      // 'Authorization':  `Bearer ${token}`,
      // 'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjo5NywidXNlcl9pZCI6MTAwODMsIm9yZ19pZCI6MCwidXNlcl9rZXkiOiI4MDhhOGFhNC1hODBkLTQ2MTgtYWFhYS05OGFhMDZiZjhkZGYiLCJkZXZpY2VfdHlwZSI6IkFkbWluIiwidXNlcm5hbWUiOiIxMzEyMzQ1Njc4OSJ9.VpuEio7AYezrz0th46937Ci9corawKYVvwDkGsNhelrQDvpNSS-Wd17NzCR-Z6127g4MqgPSWDDgzZ55KidOtA`,
      'Device-Type': 'app' 
    }
  })
}

// 获取答题卡
export function answerSheet(data) {
  return request({
    url: `/exam/proprietaryStudyQuestionRecord/answerSheet`,
    method: 'post',
    data,
    headers: {
      // 'Authorization':  `Bearer ${token}`,
      // 'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjo5NywidXNlcl9pZCI6MTAwODMsIm9yZ19pZCI6MCwidXNlcl9rZXkiOiI4MDhhOGFhNC1hODBkLTQ2MTgtYWFhYS05OGFhMDZiZjhkZGYiLCJkZXZpY2VfdHlwZSI6IkFkbWluIiwidXNlcm5hbWUiOiIxMzEyMzQ1Njc4OSJ9.VpuEio7AYezrz0th46937Ci9corawKYVvwDkGsNhelrQDvpNSS-Wd17NzCR-Z6127g4MqgPSWDDgzZ55KidOtA`,
      'Device-Type': 'app' 
    }
  })
}

// 智能组题答题卡
export function combinationAnswerSheet(studyPaperId) {
  return request({
    url: `/exam/proprietaryStudyPaper/answerSheet/${studyPaperId}`,
    method: 'get',
    headers: {
      // 'Authorization':  `Bearer ${token}`,
      // 'Authorization': `eyJhbGciOiJIUzUxMiJ9.eyJhY2NvdW50X2lkIjo5NywidXNlcl9pZCI6MTAwODMsIm9yZ19pZCI6MCwidXNlcl9rZXkiOiI4MDhhOGFhNC1hODBkLTQ2MTgtYWFhYS05OGFhMDZiZjhkZGYiLCJkZXZpY2VfdHlwZSI6IkFkbWluIiwidXNlcm5hbWUiOiIxMzEyMzQ1Njc4OSJ9.VpuEio7AYezrz0th46937Ci9corawKYVvwDkGsNhelrQDvpNSS-Wd17NzCR-Z6127g4MqgPSWDDgzZ55KidOtA`,
      'Device-Type': 'app' 
    }
  })
}